/**
 * Sets a parameter on a URLSearchParams instance.
 * @param params The URLSearchParams instance.
 * @param paramName The parameter name.
 * @param newValue The parameter value.
 */
export function setParameterValue(params: URLSearchParams, paramName: string, newValue: string | undefined): void {
	if (newValue) {
		params.set(paramName, newValue);
	}
	else {
		params.delete(paramName);
	}
}